import ActiveRecord from './base/ActiveRecord';

class Make extends ActiveRecord {

    constructor(name) {
        super(name);
        this.form = {
            name: ''
        };
    }
}

export default Make;
